import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";
import axios from "axios";

export const studySiteDataEntryServices = {
  //Study 
  getStudySiteEventSchema,
  getStudySiteSubjectList,
  getStudySiteSubjectStatus,
  getStudySiteLarList,
  repeatStudySubjectEvent,
  getStudySiteEventDataBasedonSchema,
  getStudySiteEventTimePointDataBasedonEvent,
  getStudyFormListBasedonEventSchema,

  // Please remove these API afer implementation
  deleteTimeUserStudySubjectDataEntry,

  //Data Entry
  uploadDocumentData,
  updateTimeUserStudySubjectDataEntry,
  addNewStudySubjectDataEntry,
  repeatStudySubjectEventForm,
  getStudySubjectDataEntry,
  getStudySubjectLogDataEntry,
  getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
  getStudySubjectFormFieldReviewHistoryDataEntry,
  getStudySubjectFormFieldQueryHistoryDataEntry,
  getStudySubjectFormFieldQueryNotificationDataEntry,
  generateManualQueryStatusStudySubjectFormField,
  generateQueryNotificationStatusStudySubjectFormField,
  queryDiscussionStudySubjectFormField,
  getStudyDataEntryFieldUpdatedHistoryList,
  getStudySubjectFormFieldQueryDiscussionDataEntry,
  generateManualQueryStudySubjectFormFieldDataEntry,
  unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry,
  signatureStudySubjectFormReviewFieldHistoryDataEntry,
  signatureStudySubjectFormReviewAllFieldDataEntry,
  signatureStudySubjectFormReviewHistoryDataEntry,
  getStudySubjectFormReviewHistoryDataEntry,

  //Data Entry
  getStudyBySiteFormDataEntry,
  getStudyBySiteSubjectFormDataEntry,

  //SDV Management
  storeStudyFormSDVHistory,
  getStudyFormSDVHistory,
  getStudyBySiteFormSDVHistory,
  getStudyBySiteSubjectFormSDVHistory,
  getStudyFormSiteWiseTotalSDV,
  getStudySitePerformanceSDVSummery,
  getStudyUserActivitySDVSummery,
  getStudyFormSiteWiseTotalFormLevelSDV,

  //Query Management
  storeStudyFormFieldQueryHistory,
  getStudyFormBySiteTotalQuery,
  getStudyFormBySiteSubjectTotalQuery,
  getStudyFormFieldQueryHistory,
  getStudyFormSiteWiseTotalQuery,
  getStudyFormSiteWiseTotalFormLevelQuery,
  getStudySitePerformanceQuerySummery,
  getStudyUserActivityQuerySummery,

  //Notification Management
  storeStudyFormFieldNotificationHistory,
  getStudyFormBySiteSubjectTotalNotification,
  getStudyFormBySiteTotalNotification,
  getStudyFormFieldNotificationHistory,
  getStudyFormSiteWiseTotalNotification,
  getStudyFormSiteWiseTotalFormLevelNotification,
  getStudySitePerformanceNotificationSummery,
  getStudyUserActivityNotificationSummery,
};

// Get Study Event Schema
async function getStudySiteEventSchema(studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteEventSchema/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
// Get Study Subject List
async function getStudySiteSubjectList(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectList/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
// Get Study Subject Status
async function getStudySiteSubjectStatus(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectStatus/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Lar List
async function getStudySiteLarList(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteLarList/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Site Data based on Schema
async function getStudySiteEventDataBasedonSchema(studyId, siteId, schemaId, subjectId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteEventDataBasedonSchema/${studyId}/${siteId}/${schemaId}/${subjectId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Site Event Time Point Data based on Event
async function getStudySiteEventTimePointDataBasedonEvent(studyId, siteId, schemaId, eventId, subjectId, repeatType, repeatEventId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteEventTimePointDataBasedonEvent/${studyId}/${siteId}/${schemaId}/${eventId}/${subjectId}/${repeatType}/${repeatEventId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form List Based on Event Schema
async function getStudyFormListBasedonEventSchema(studyId, siteId, subjectId, schemaId, eventId, timePointUniqueId, type, viewType, repeatEventId, repeatTimePointId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormListBasedonEventSchema/${studyId}/${siteId}/${subjectId}/${schemaId}/${eventId}/${timePointUniqueId}/${type}/${viewType}/${repeatEventId}/${repeatTimePointId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Subject Data Entry Time and User
async function deleteTimeUserStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteTimeUserStudySubjectDataEntry`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Subject Data Entry Time and User
async function updateTimeUserStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateTimeUserStudySubjectDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Repeat Study Subject Event 
async function repeatStudySubjectEvent(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}repeatStudySubjectEvent`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add Subject Data Entry
async function addNewStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Upload File Get Url
async function uploadDocumentData(formData) {
  try {
    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadDocumentData`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Upload document failed:", error);
    handleResponse({
      statusCode: 400,
      customMessage: error?.response?.data?.message || "Something went wrong on upload"
    })
  }
}

// // Repeat Study Subject Event Form
async function repeatStudySubjectEventForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}repeatStudySubjectEventForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add Subject Data Entry
async function getStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Add Subject Log Data Entry
async function getStudySubjectLogDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectLogDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Freeze Unfreeze  History
async function getStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFreezeUnfreezeHistoryDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Field Review  History
async function getStudySubjectFormFieldReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldReviewHistoryDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Field Query History
async function getStudySubjectFormFieldQueryHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryHistoryDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Field Query Notification
async function getStudySubjectFormFieldQueryNotificationDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryNotificationDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Generate Manual Query Status
async function generateManualQueryStatusStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateManualQueryStatusStudySubjectFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Generate Query Nofitication Status
async function generateQueryNotificationStatusStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateQueryNotificationStatusStudySubjectFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Generated Query Discussion
async function queryDiscussionStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}queryDiscussionStudySubjectFormField`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Data Entry Field Updated History
async function getStudyDataEntryFieldUpdatedHistoryList(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDataEntryFieldUpdatedHistoryList`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Field Query Discussion
async function getStudySubjectFormFieldQueryDiscussionDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryDiscussionDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Unfreze Study Subject Form Freeze Unfreeze  History
async function unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Generate Manual Query Study Subject Form Field
async function generateManualQueryStudySubjectFormFieldDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateManualQueryStudySubjectFormFieldDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Signature Study Subject Form Field Review  History
async function signatureStudySubjectFormReviewFieldHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewFieldHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Signature Study Subject Form All Field Review
async function signatureStudySubjectFormReviewAllFieldDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewAllFieldDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study by Site Form Data Entry
async function getStudyBySiteFormDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteFormDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study by Site and Subject Form Data Entry
async function getStudyBySiteSubjectFormDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteSubjectFormDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Store Study Form SDV History
async function storeStudyFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}storeStudyFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form SDV History
async function getStudyFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site Form SDV History
async function getStudyBySiteFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site and Subject Form SDV History
async function getStudyBySiteSubjectFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteSubjectFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Store Study Form Field Query History
async function storeStudyFormFieldQueryHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}storeStudyFormFieldQueryHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Field Query History
async function getStudyFormFieldQueryHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormFieldQueryHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site Total Query
async function getStudyFormBySiteTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}
// Get Study By Site and Subject Total Query
async function getStudyFormBySiteSubjectTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteSubjectTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Query Statistics
async function getStudyFormSiteWiseTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form SDV Statistics
async function getStudyFormSiteWiseTotalSDV(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalSDV`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study SDV Site Performance
async function getStudySitePerformanceSDVSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceSDVSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study User Activity SDV Summery
async function getStudyUserActivitySDVSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivitySDVSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Site Wise Total Form Level SDV
async function getStudyFormSiteWiseTotalFormLevelSDV(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelSDV`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Query Statistics
async function getStudyFormSiteWiseTotalFormLevelQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Query Site Performance
async function getStudySitePerformanceQuerySummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceQuerySummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Query User Activity
async function getStudyUserActivityQuerySummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivityQuerySummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Store Study Form Field Notification History
async function storeStudyFormFieldNotificationHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}storeStudyFormFieldNotificationHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Field Notification History
async function getStudyFormFieldNotificationHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormFieldNotificationHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Notification Statistics
async function getStudyFormSiteWiseTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site Total Query
async function getStudyFormBySiteTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site and Subject Total Query
async function getStudyFormBySiteSubjectTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteSubjectTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Notification Statistics
async function getStudyFormSiteWiseTotalFormLevelNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Notification Site Performance
async function getStudySitePerformanceNotificationSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceNotificationSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Notification User Activity
async function getStudyUserActivityNotificationSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivityNotificationSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Signature Study Subject Form Review  History
async function signatureStudySubjectFormReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Subject Form Review  History
async function getStudySubjectFormReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormReviewHistoryDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}